// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/swiper-bundle.css";
// import ProductSlider from "./ProductSlider";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// function Discounts() {
//    const { tokenDetails } = useSelector((state) => state.user);
//    const navigate=useNavigate();
//    const handle3d = () => {
//     console.log("Don");
//     if (!tokenDetails) {
//       toast.error("Please login or Signup");
//       return;
//     }
//     navigate("/3d-product");
//   };
//   return (
//     <div>
//       <div className="cms-section  pos-5 cms-section-default" style={{}}>
//         <div className="cms-section-default full-width">
//           <div className="cms-block block-container-3 pos-0 cms-block-shield-usp-blocks">
//             <div className="cms-block-container">
//               <div className="cms-block-container-row row cms-row ">
//                 <div className="col-12">

// <div className="why-order-section" style={{  backgroundColor: "#f8f9fa" }}>
//   <div className="container">
//     <h2 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "40px", fontSize: "28px" }}>
//       Why Order from Shield Sports?
//     </h2>

//     <div className="row align-items-center">
//       {/* Left side - Content */}
//       <div className="col-lg-6 col-md-12 order-lg-1 order-2">
//         <div className="benefit-item" style={{
//           padding: "20px",
//           marginBottom: "20px",

//           borderRadius: "8px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//           transition: "transform 0.3s ease, box-shadow 0.3s ease",
//           animation: "fadeInLeft 0.6s ease-out"
//         }}>
//           <div className="d-flex align-items-center">
//             <div style={{ marginRight: "15px", flexShrink: 0 }}>
//               <img
//                 src="/asset/icon6.svg"
//                 width="40"
//                 height="40"
//                 alt="Trusted"
//                 style={{ transition: "transform 0.3s ease" }}
//               />
//             </div>
//             <div>
//               <h3 style={{
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 marginBottom: "8px",
//                 color: "#333"
//               }}>
//                 Trusted by Thousands
//               </h3>
//               <p style={{
//                 fontSize: "14px",
//                 color: "#666",
//                 marginBottom: 0,
//                 lineHeight: 1.5
//               }}>
//                 Rated 4.8/5 on Google, we provide end-to-end transparency, from design to delivery.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="benefit-item" style={{
//           padding: "20px",

//           borderRadius: "8px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//           transition: "transform 0.3s ease, box-shadow 0.3s ease",
//           animation: "fadeInLeft 0.6s ease-out 0.2s",
//           animationFillMode: "both"
//         }}>
//           <div className="d-flex align-items-center">
//             <div style={{ marginRight: "15px", flexShrink: 0 }}>
//               <img
//                 src="/asset/icon5.svg"
//                 width="40"
//                 height="40"
//                 alt="Discounts"
//                 style={{ transition: "transform 0.3s ease" }}
//               />
//             </div>
//             <div>
//               <h3 style={{
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 marginBottom: "8px",
//                 color: "#333"
//               }}>
//                 Incredible Bulk Discounts
//               </h3>
//               <p style={{
//                 fontSize: "14px",
//                 color: "#666",
//                 marginBottom: 0,
//                 lineHeight: 1.5
//               }}>
//                 We build long-term partnerships by offering exclusive team and corporate pricing.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="benefit-item" style={{
//           padding: "20px",
//           marginBottom: "20px",

//           borderRadius: "8px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//           transition: "transform 0.3s ease, box-shadow 0.3s ease",
//           animation: "fadeInLeft 0.6s ease-out 0.4s",
//           animationFillMode: "both"
//         }}>
//           <div className="d-flex align-items-center">
//             <div style={{ marginRight: "15px", flexShrink: 0 }}>
//               <img
//                 src="/asset/icon6.svg"
//                 width="40"
//                 height="40"
//                 alt="Payments"
//                 style={{ transition: "transform 0.3s ease" }}
//               />
//             </div>
//             <div>
//               <h3 style={{
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 marginBottom: "8px",
//                 color: "#333"
//               }}>
//                 Fast & Secure Payments
//               </h3>
//               <p style={{
//                 fontSize: "14px",
//                 color: "#666",
//                 marginBottom: 0,
//                 lineHeight: 1.5
//               }}>
//                 Enjoy seamless and secure payment options for a smooth transaction experience.
//               </p>
//             </div>
//           </div>
//         </div>
//          <div className="benefit-item" style={{
//           padding: "20px",

//           borderRadius: "8px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//           transition: "transform 0.3s ease, box-shadow 0.3s ease",
//           animation: "fadeInLeft 0.6s ease-out 0.4s",
//           animationFillMode: "both"
//         }}>
//           <div className="d-flex align-items-center">
//             <div style={{ marginRight: "15px", flexShrink: 0 }}>
//               <img
//                 src="/asset/icon6.svg"
//                 width="40"
//                 height="40"
//                 alt="Payments"
//                 style={{ transition: "transform 0.3s ease" }}
//               />
//             </div>
//             <div>
//               <h3 style={{
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 marginBottom: "8px",
//                 color: "#333"
//               }}>
//                Worldwide Shipping
//               </h3>
//               <p style={{
//                 fontSize: "14px",
//                 color: "#666",
//                 marginBottom: 0,
//                 lineHeight: 1.5
//               }}>
//                  We offer global shipping for our customized jerseys.
//               </p>
//             </div>

//           </div>
//         </div>
//       </div>

//       <div className="col-lg-6 col-md-12 order-lg-2 order-1 mb-4 mb-lg-0">
//         <div style={{
//           textAlign: "center",
//           animation: "fadeInRight 0.6s ease-out"
//         }}>
//           <img
//             src="/asset/img/Ecom/14 (2).webp"
//             alt="Shield Sports Jersey"
//             className=""
//             style={{
//          height:"70%",

//             maxWidth:"70%",
//               borderRadius: "8px",
//               boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
//               transition: "transform 0.3s ease"
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   </div>

//   {/* CSS for animations */}
//   <style jsx>{`
//     @keyframes fadeInLeft {
//       from {
//         opacity: 0;
//         transform: translateX(-20px);
//       }
//       to {
//         opacity: 1;
//         transform: translateX(0);
//       }
//     }

//     @keyframes fadeInRight {
//       from {
//         opacity: 0;
//         transform: translateX(20px);
//       }
//       to {
//         opacity: 1;
//         transform: translateX(0);
//       }
//     }

//     .benefit-item:hover {
//       transform: translateY(-5px);
//       box-shadow: 0 8px 20px rgba(0,0,0,0.1);
//     }

//     .benefit-item:hover img {
//       transform: scale(1.1);
//     }

//     @media (max-width: 991px) {
//       .why-order-section {

//       }

//       .benefit-item {

//       }
//     }

//     @media (max-width: 767px) {
//       .why-order-section {

//       }
//           .container{
//         max-width: 100%;
//     }
//       h2 {
//         font-size: 24px !important;

//       }
//     }
//   `}</style>
// </div>

//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="cms-block block-container-2 pos-1 cms-block-image-cover">
//             <div className="cms-block-container">
//               <div className="cms-block-container-row row cms-row ">
//                 <div
//                   className="col-12"
//                   data-cms-element-id="0191992ef05d7605879d0b8fc6d36856"
//                 >
//                   <div className="cms-element-image center-content-start" style={{cursor:"pointer"}}>
//                     {/* <a
//                       className="cms-image-link"
//                       onClick={handleNavigation}
//                     > */}
//                       <div
//                         className="cms-image-container is-cover"
//                         // style={{ minHeight: "340px" }}
//                         onClick={() => {
//                         handle3d();
//                       }}

//                       >
//                         <img
//                           // width="1920"
//                           // height="622"
//                           //   src="asset/img/img/no-imageb090.svg?1729065116"
//                           src="Images/BannerSports4.webp"
//                           className=""
//                           loading="lazy"
//                           style={{width:"100%"}}
//                           // data-object-fit="cover"
//                         />
//                         {/* <img
//                           width="600"
//                           height="600"
//                           //   src="asset/img/img/no-imageb090.svg?1729065116"
//                           src="Images/BannerSports4.webp"
//                           className="cms-image f_lazy mobile-image-view"
//                           loading="lazy"
//                           data-object-fit="cover"
//                         /> */}
//                       </div>
//                     {/* </a> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <ProductSlider />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Discounts;

import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../Styles/SportsSlider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import ProductSlider from "./ProductSlider";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { homefilterApi } from "../../Services/Operations/ProductAPI";
import zIndex from "@mui/material/styles/zIndex";
import Marquee from "react-fast-marquee";

function Discounts() {
  const { tokenDetails } = useSelector((state) => state.user);
  const [jerseys, setJerseys] = useState([{},{}]);
  const navigate = useNavigate();
  const divOne=useRef(null)
  const[distanceOne,setDistanceOne]=useState(0)
  const [mobile,setMobile]=useState(window.innerWidth<567?true:false)

  const divTwo=useRef(null)
  const[distanceTwo,setDistanceTwo]=useState(0)

   useEffect(() => {
    const handleScroll = () => {
      if (divOne.current) {
        const rect = divOne.current.getBoundingClientRect();
        setDistanceOne(rect.top); // distance from viewport top
      }
    };

    // Run once and on scroll
    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

   useEffect(() => {
    const handleScroll = () => {
      if (divTwo.current) {
        const rect = divTwo.current.getBoundingClientRect();
        setDistanceTwo(rect.top); // distance from viewport top
      }
    };

    // Run once and on scroll
    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handle3d = () => {
    console.log("Don");
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }
    navigate("/3d-product");
  };

  const settings1 = {
    // infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    // autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };
  const settings = {
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
     speed: 5000,             // long duration for smooth continuous effect
  autoplaySpeed: 0,        // remove pause between transitions
  cssEase: "linear",       // smooth linear movement

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };

  useEffect(() => {
    const fetchCricket = async () => {
      try {
        const products = await homefilterApi("NFL football");
        console.log("Products for socker :", products);
        setJerseys(products.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchCricket();
  }, []);

  const handleProductClick = (jersey, slug) => {
    console.log("jersey : ", jersey);
    navigate(`/detailsPage/${slug}`);
  };

  const tickets=[
    {text:"Exciting Offers"},
     {text:"100% Secure Payments"},
      {text:"Premium Fabrics"},
       {text:"Exciting Offers"},
     {text:"100% Secure Payments"},
      {text:"Premium Fabrics"},
     

  ]

  return (
    <div>


      <div className="cms-section  pos-5 cms-section-default" style={{backgroundColor:"white"}}>
        <div className="cms-section-default full-width">

           <div style={{display:"flex", alignItems:"center",width:"100%", justifyContent:"space-around",paddingLeft:mobile?"20px":"50px",backgroundColor:"black",
                        marginTop:mobile?"17px":"25px",}}>
                          <div style={{position:"absolute",color:"white",backgroundColor:"black",width:mobile?"100px":"150px",height:mobile?"40px":"40px",paddingRight:"1px",paddingLeft:"10px",display:"flex",alignItems:"center",
                            fontSize:mobile?"12px":"23px",zIndex:1000,left:mobile?"20px":"50px",fontWeight:600,borderLeft:"4px solid yellow",borderBottomRightRadius:"10px",}}>
                            FEATURED
                          </div>
          
          
                          <div style={{width:"100%",background:"yellow",overflow:"hidden",height:mobile?"40px":"40px",}}>
                         
                            <Marquee
                                                                           speed={50}          // Adjust speed (higher = faster)
                                                                            gradient={false}    // Disable fade gradient at edges
                                                                             pauseOnHover={true} // Optional: pause on hover
                                                                                style={{background:"yellow",width:"180%",height:"50px"}}   
                                                                                  >
                            {
                              tickets.map((ticket,index)=>(
                                <div key={index} 
                                style={{display:"flex",alignItems:"center",justifyContent:"center",backgroundColor:"yellow",height:mobile?"60px":"90px"}} >
                                 <p style={{fontSize:mobile?"15px":"20px",fontWeight:500,paddingRight:"50px",backgroundColor:"yellow",height:mobile?"40px":"40px",display:"flex",alignItems:"center",justifyContent:"center"}}>{ticket.text}</p>
                                  </div>
                              ))
                            }
                        
                       </Marquee>
                        
                          </div>
                        
             </div>




          <div
            style={{
              backgroundColor: "white",
              padding: "10px 20px",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <p
                style={{fontSize:window.innerWidth <= 567?"18px":"48px" ,color:"black",fontWeight:window.innerWidth <= 567?700:500,padding: window.innerWidth <= 567?"5px":"20px",textAlign:window.innerWidth <= 567?"center":"center"}} 
              >
                Latest NFL Football Jerseys
                <br/>
              {window.innerWidth<567 &&   <span style={{fontFamily:"Poppins",color:"gray",fontSize:"12px",textAlign:"center",fontWeight:"normal"}}>
                  Book your NFL football team jersey</span>}

              </p>

              

              {window.innerWidth>567 &&<Slider {...settings1} className="jersey-slider">
                  {jerseys.map((jersey) => {
                    const discount =
                      jersey.size && jersey.size.length > 0
                        ? jersey.size[0].discount_percent
                        : 0;
                    const price =
                      jersey.size && jersey.size.length > 0
                        ? jersey.size[0].price
                        : 0;
                    const mrp =
                      jersey.size && jersey.size.length > 0
                        ? jersey.size[0].mrp
                        : 0;

           function limitTextToWords(text, wordLimit) {
             if (typeof text !== 'string') return '';
  const words = text.trim().split(/\s+/); // split by whitespace
  if (words.length <= wordLimit) return text;
  return words.slice(0, wordLimit).join(' ') + '...';
}

                    return (
                      <div key={jersey.id} style={{ padding: "0 8px",background: "linear-gradient(white, rgb(255, 230, 255))" }}>
                        <div
                          style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            overflow: "hidden",
                          // width:"330px",
                            transition: "all 0.3s ease",
                            transform: "translateY(0)",
                          
                            position: "relative",
                          }}
                          className="jersey-card"
                          
                        >
                          <div
                            style={{
                              position: "relative",
                              overflow: "hidden",
                              height: "235px",
                              // width:"320px"
                            }}
                          >
                            <img
                              src={jersey.image}
                              alt={jersey.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                transition: "transform 0.5s ease",
                                borderRadius: "0px",
                              }}
                              className="jersey-image"
                            />
                              <img style={{position:"absolute",top:5,right:5,width:"25px"}}
                      src="/asset/img/heart.png"/>
                       <p style={{position:"absolute",borderRadius:"5px",top:0,left:0,fontSize:'10px',padding:"5px",background:"linear-gradient(to right, #05e2ffff, #0fbea1ff)",color:"white"}}>
                        Exclusive</p>
                          </div>

                          <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}} > 
                          <div style={{ padding: "3px",paddingLeft:'10px',paddingRight:"10px" }}>
                            <p
                              style={{
                                fontSize: "16px",
                                fontWeight: 700,
                                fontStyle:"bold",
                                
                                marginBottom: "4px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                fontFamily:"inherit",
                                textOverflow: "ellipsis",
                                color:"black"
                              }}
                            >
                              {jersey.name}
                            </p>
                            <p style={{fontSize:"12px",fontWeight:"bold",color:"gray",marginBottom: "0.4rem"}}>
                              {limitTextToWords( jersey.name,10) }
                            </p>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "4px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 700,
                                  fontStyle:"bold",
                                  color: "black",
                                  fontFamily:"ITF Devanagari"
                                }}
                              >
                                ${price}
                              </span>
                              <span
                                style={{
                                  fontSize: "15px",
                                  color: "#686767ff",
                                  textDecoration: "line-through",
                                   fontFamily:"ITF Devanagari"
                                }}
                              >
                                ${mrp}
                              </span>
                              <span
                                style={{width:"51px",height:"17px",borderRadius:"20px",backgroundColor:"#F1A3A3",
                                  color:"#CE0505",
                                   fontSize: "11px",textAlign:"center" }}
                              >
                               {"-"} {Math.round(((mrp - price) / mrp) * 100)}%
                              </span>
                            </div>
                            </div>
                            <p  onClick={(e) => {
                            e.preventDefault();
                            handleProductClick(jersey, jersey.slug);
                          }}
                            style={{marginLeft:"9px",cursor:"pointer",borderBottom:"1.5px solid black",width:"fit-content",fontSize:'15px',fontWeight:"bold"}}>Shop Now
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>}

                  {window.innerWidth <= 567 && 
                                           <Slider {...settings1} className="jersey-slider" style={{backgroundColor:"white"}}>
                                                      {jerseys.map((jersey) => {
                                                        const discount =
                                                          jersey.size && jersey.size.length > 0
                                                            ? jersey.size[0].discount_percent
                                                            : 0;
                                                        const price =
                                                          jersey.size && jersey.size.length > 0
                                                            ? jersey.size[0].price
                                                            : 0;
                                                        const mrp =
                                                          jersey.size && jersey.size.length > 0 ? jersey.size[0].mrp : 0;
                                          
                                                        return (
                                                          <div
                                                            key={jersey.id}
                                                            style={{
                                                              padding: "0 8px",
                                                              background: "linear-gradient(white, rgb(255, 230, 255))",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                backgroundColor: "#ffffff",
                                                                borderRadius: "8px",
                                                                overflow: "hidden",
                                                                width:"330",
                                                            
                                                                transition: "all 0.3s ease",
                                                                transform: "translateY(0)",
                                                               
                                                                position: "relative",
                                                              }}
                                                              className="jersey-card"
                                                              
                                                            >
                                                              <div
                                                                style={{
                                                                  position: "relative",
                                                                  overflow: "hidden",
                                                                  height: "180px",
                                                                  width:"240"
                                                                }}
                                                              >
                                                                <img
                                                                  src={jersey.image}
                                                                  alt={jersey.name}
                                                                  style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "contain",
                                                                    transition: "transform 0.5s ease",
                                                                    borderRadius: "0px",
                                                                  }}
                                                                  className="jersey-image"
                                                                />
                                                                  <img style={{position:"absolute",top:5,right:5,width:"25px"}}
                                                                src="/asset/img/heart.png"/>
                                                               <p style={{position:"absolute",borderRadius:"5px",top:0,left:0,fontSize:'10px',padding:"5px",background:"linear-gradient(to right, #05e2ffff, #0fbea1ff)",color:"white"}}>
                        Exclusive</p>
                                                              </div>
                                          
                                                              <div style={{ }}>
                                                                <p
                                                                  style={{
                                                                    fontSize: "12px",
                                                                    fontWeight: 700,
                                                                    fontStyle:"bold",
                                                                    color: "#000000ff",
                                                                    marginBottom: "4px",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                  }}
                                                                  onClick={(e) => {
                                                      e.preventDefault();
                                                      handleProductClick(jersey, jersey.slug);
                                                    }}
                                                                >
                                                                  {jersey.name}
                                                                </p>
                                                                <p style={{fontSize:"8px",fontWeight:"bold",color:"gray"}}>{jersey.name}</p>
                                          
                                                                {/* {discount > 0 && (
                                                                        <div
                                                                          style={{
                                                                            position: "absolute",
                                                                            top: "10px",
                                                                            right: "10px",
                                                                            backgroundColor: "#ff3e6c",
                                                                            color: "white",
                                                                            padding: "4px 8px",
                                                                            borderRadius: "4px",
                                                                            fontSize: "12px",
                                                                            fontWeight: "bold",
                                                                          }}
                                                                        >
                                                                          {discount}% OFF
                                                                        </div>
                                                                      )} */}
                                          
                                                                <div
                                                                  style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                    marginBottom: "4px",
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      fontSize: "12px",
                                                                      fontWeight: 700,
                                                                      fontStyle:"bold",
                                                                      color: "black",
                                                                     fontFamily:"ITF Devanagari"
                                                                    }}
                                                                  >
                                                                    ${price}
                                                                  </span>
                                                                  <span
                                                                    style={{
                                                                      fontSize: "10px",
                                                                      color: "#504f50ff",
                                                                      fontWeight:700,
                                                                      fontStyle:"bold",
                                                                      textDecoration: "line-through",
                                                                      fontFamily:"ITF Devanagari"
                                                                    }}
                                                                  >
                                                                    ${mrp}
                                                                  </span>
                                                                  <span style={{width:"25px",height:"10px",borderRadius:"20px",textAlign:"center",
                                                                     fontSize: "7px", color: "#CE0505",backgroundColor:"#F1A3A3" }}>
                                                                    {"-"}{Math.round(((mrp - price) / mrp) * 100)}%
                                                                  </span>
                                                                </div>
                                                                <p  onClick={(e) => {
                                                                      e.preventDefault();
                                                                      handleProductClick(jersey, jersey.slug);
                                                                    }}
                                                                      style={{cursor:'pointer',borderBottom:"1.5px solid black",width:"fit-content",fontSize:'12px',fontWeight:"bold"}}>Shop Now
                                                                      </p>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        );
                                                      })}
                                             </Slider>}
            </div>

            <style jsx global>{`
              .jersey-slider .slick-prev:before,
              .jersey-slider .slick-next:before {
                color: #4f46e5;
                font-size: 24px;
              }
                 .slick-list{
            background-color:white
            }

              .jersey-slider .slick-dots li button:before {
                font-size: 12px;
                color: #4f46e5;
              }

              .jersey-slider .slick-dots li.slick-active button:before {
                color: #4f46e5;
                opacity: 1;
              }

              .jersey-slider .slick-slide {
                padding: 0 10px;
              }

              .jersey-card:hover {
                box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
                  0 10px 10px -5px rgba(0, 0, 0, 0.04);
                transform: translateY(-4px);
              }

              .jersey-image:hover {
                transform: scale(1.05);
              }
            `}</style>
          </div>
          <div className="cms-block block-container-3 pos-0 cms-block-shield-usp-blocks">
            <div className="cms-block-container">
              <div className="cms-block-container-row row cms-row ">
                <div className="col-12">
                  <div
                    className="why-order-section"
                    style={{ backgroundColor: "white" }}
                  >
                     
              
                     

                    {/* CSS for animations */}
                    <style jsx>{`
                      @keyframes fadeInLeft {
                        from {
                          opacity: 0;
                          transform: translateX(-20px);
                        }
                        to {
                          opacity: 1;
                          transform: translateX(0);
                        }
                      }

                      @keyframes fadeInRight {
                        from {
                          opacity: 0;
                          transform: translateX(20px);
                        }
                        to {
                          opacity: 1;
                          transform: translateX(0);
                        }
                      }

                      .benefit-item:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
                      }

                      .benefit-item:hover img {
                        transform: scale(1.1);
                      }

                      @media (max-width: 991px) {
                        .why-order-section {
                        }

                        .benefit-item {
                        }
                      }

                      @media (max-width: 767px) {
                        .why-order-section {
                        }
                        .container {
                          max-width: 100%;
                        }
                        h2 {
                          font-size: 17px !important;
                        }
                      }
                    `}</style>
                  </div>
                </div>
              </div>
            </div>
          </div>
           <div className="my-6"
           style={{width:"screen",position:"relative",display:"flex",alignItems:"center"}}>
                          <img src="/asset/img/Special banner.jpg" style={{width:"100%",height:"100%"}}/>
                       
                      </div>

          <ProductSlider />
        </div>
      </div>
    </div>
  );
}

export default Discounts;
